export default __webpack_public_path__ + "static/media/chevrot.cc9e543f.svg";